import { router } from '@inertiajs/react'

export function useDeleteWithConfirmation(baseUrl) {
  const handleDelete = (item, options = {}) => {
    const {
      nameField = 'name',
      customMessage = null,
      onSuccess = null
    } = options

    const name = item[nameField]
    const message = customMessage || `Delete "${name}"? This cannot be undone.`

    if (confirm(message)) {
      router.delete(`${baseUrl}/${item.id}`, {
        onSuccess
      })
    }
  }

  return handleDelete
}
